import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import { RevenueCalendarCell } from 'components/Calendar/index'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getClosedDates, getSpecialHolidays } from 'reducks/calendar/selectors'
import { isAfter, isBefore } from 'date-fns'
import { OrderType } from 'types/checkout'
import { getOrders } from 'reducks/checkout/selectors'
import { dateToString, parseToDate } from 'lib/helper'
import { SpecialHolidayType } from 'types/calendar'

type Props = {
  accountingType: 'order' | 'deliver'
  selectedStartDate: Date
  selectedEndDate: Date
  startMonth: Date
  endMonth: Date
  selectDate: (date: Date) => void
  row: Date[]
}

const RevenueCalendarRow: FC<Props> = (props) => {
  const { accountingType, selectedStartDate, selectedEndDate, startMonth, endMonth, selectDate, row } = props

  const orders: OrderType[] = useSelector((state: State) => getOrders(state))
  const closedDates: Date[] = useSelector((state: State) => getClosedDates(state))
  const specialHolidays: SpecialHolidayType[] = useSelector((state: State) => getSpecialHolidays(state))

  return (
    <tr className={styles.table__row}>
      {row.map((date) => {
        const isClosed = closedDates.some((closedDate) => isSameDay(closedDate, date))
        const isOrdered = orders.some((order) => {
          if (accountingType === 'order') {
            return isSameDay(order.checkout_at ? order.checkout_at.toDate() : order.updated_at.toDate(), date)
          } else {
            return isSameDay(parseToDate(order.date), date)
          }
        })
        const isSpecialHoliday = specialHolidays.some((specialHoliday) => specialHoliday.date === dateToString(date))
        const isStartDate = isSameDay(date, selectedStartDate)
        const isEndDate = isSameDay(date, selectedEndDate)
        const isInPeriod = isAfter(date, selectedStartDate) && isBefore(date, selectedEndDate)

        return (
          <RevenueCalendarCell
            key={getDate(date)}
            date={date}
            startMonth={startMonth}
            endMonth={endMonth}
            selectDate={selectDate}
            isClosed={isClosed}
            isOrdered={isOrdered}
            isSpecialHoliday={isSpecialHoliday}
            isStartDate={isStartDate}
            isEndDate={isEndDate}
            isInPeriod={isInPeriod}
          />
        )
      })}
    </tr>
  )
}

export default RevenueCalendarRow
